import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'amfe-flexible'
import '../src/assets/font/font.css'
import '../src/assets/icon/iconfont.css'
import 'animate.css'
import '@/assets/style.css'
import 'swiper/css/swiper.css'
// import Nprogress from 'nprogress'
import 'nprogress/nprogress.css'
// import axios from 'axios'
import moment from 'moment'
import VueRouter from 'vue-router'
import xcUtils from './utils/xcUtils'
import curUtils from './utils/curUtils'
import chnEngStatusCode from './utils/chnEngStatusCode'
import userInfo from './utils/userInfo'
import http from './http/request'
import env from './http/env.js'
import './style/common.less'

// 拖拽拼图校验
import puzzleVerification from 'vue-puzzle-verification'
import cebsbLoading from '@/components/cebsbLoading/index.js'
import VueI18n from 'vue-i18n' // 国际化
import ToolComponent from '@/components/auth/ToolComponent.vue'
import gameStageBackview from '@/permission/gameStageBackview.vue'
Vue.component('ToolComponent', ToolComponent)
Vue.component('gameStageBackview', gameStageBackview)

Vue.use(cebsbLoading)
Vue.use(VueI18n)
Vue.prototype.$xcUtils = xcUtils
Vue.prototype.$curUtils = curUtils
Vue.prototype.$chnEngStatusCode = chnEngStatusCode
Vue.prototype.$userInfo = userInfo
Vue.prototype.$http = http
Vue.prototype.$env = env
// moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.use(puzzleVerification)
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'ZH', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    ZH: require('../src/i18n/lan/zh'), // 本地资源文件，我这里配2个语言，中文&英文，src下根据个人情况放置
    EN: require('../src/i18n/lan/en')
  }
})
// 设置rem根
function setRootFontSize () {
  const DESIGN_WIDTH = 180
  const DESIGN_HEIGHT = 70
  const designRatio = DESIGN_WIDTH / DESIGN_HEIGHT
  const currentWidth = window.innerWidth
  const currentHeight = window.innerHeight
  const currentRatio = currentWidth / currentHeight
  let scaleRatio
  if (currentRatio > designRatio) {
    // 屏幕更宽，以高度为基准
    scaleRatio = currentHeight / DESIGN_HEIGHT
  } else {
    // 屏幕更高，以宽度为基准
    scaleRatio = currentWidth / DESIGN_WIDTH
  }
  // 设置CSS变量
  document.documentElement.style.setProperty('--scale-ratio', scaleRatio)
  // 1rem = 设计稿100px（根据需求调整）
  document.documentElement.style.fontSize = 100 * scaleRatio + 'px'
  // console.log('打印信息-----------scaleRatio', scaleRatio)
}
// 初始化执行
setRootFontSize()
// 监听窗口变化
window.addEventListener('resize', setRootFontSize)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
